module.exports = __webpack_public_path__ + "img/sns_line.37b0675d.png";